import React, { useEffect, useState } from "react";
import {
  Modal,
  Input,
  Label,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import btnUsers from "../../assets/images/icons/whiteboard-menu-a-9.svg";
import toolIcon from "../../assets/images/svg/tool-icon.svg";
import shareBaord from "../../assets/images/icons/console-control-8.svg";

const UsersTool = (props: any) => {
  const { data, setData, allPermissionSet, userPermissionSet, PermissionControl, setPermissionControl, showUserModal, toggleUserModal, toggleBoardShareModal } = props;

  return (
    <React.Fragment>
      <UncontrolledDropdown className="top-tool-group settinsTool">
        <DropdownToggle tag="button" className="feature-anchor top-tool-btn" id="top-tool-user-dropdown" data-tooltip-content="學員設定">
          <img src={btnUsers} alt="" />
        </DropdownToggle>
        <DropdownMenu>
          <div className="top-tool-group">
            <div className="top-tool-items">
              <DropdownItem onClick={() => toggleUserModal()}>
                <img src={btnUsers} style={{ width: "30px" }} alt="" />
                <div>學生列表/權限
                </div>
              </DropdownItem>
              <DropdownItem onClick={() => toggleBoardShareModal()}>
                <img src={shareBaord} style={{ width: "30px" }} alt="" />
                <div>分享白板</div>
              </DropdownItem>
            </div>
          </div>
        </DropdownMenu>
      </UncontrolledDropdown>
      <Modal id="userModal" className={`h-100 w-100 items-center justify-center m-auto`} isOpen={showUserModal} toggle={toggleUserModal} modalClassName="zoomIn" zIndex={1000120} centered>
        <div className="w-100 mt-1 text-center"><label htmlFor="qr-code" className="crs-subtitle"> 學生列表 </label></div>
        <div className="teacher-permission mb-4">
          <div><label htmlFor="qr-code" className="crs-subtitle"> 學生管理 </label></div>
          <div className="px-1">
            <div className="form-check mb-2">
              <Input
                className="form-check-input fs-15"
                type="checkbox"
                name="permissionAll"
                id="permissionAll"
                defaultChecked={PermissionControl}
                onChange={(e: any) => {
                  setPermissionControl(e.target.checked);
                  allPermissionSet(e.target.checked);
                }}
            />
              <Label className="form-check-label fs-16" htmlFor="permissionAll">
                開放所有學生互動
              </Label>
            </div>
          </div>
        </div>
        <div id="userlist" className={`list-content ${data.length === 0? "nonUsers" : ""}`}>
          <div className="layerList userList">
            {(data || []).map((item: any, index: number) => (
              <div className="layerItem" key={index}>
                <div className="layerTitle">
                  {item.username}
                </div>
                <div className="layerLock">

                </div>
                <div
                  className={`layerIcon ${!item.permission? "close-permission" : ""}`}
                  onPointerDown={(e: any) => {
                    const permission = !item.permission;
                    userPermissionSet(item.token, permission);
                  }}
                >
                  <img src={toolIcon} style={{ width: "20px" }} alt="" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default UsersTool;